import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { List } from "@styled-icons/evaicons-solid/List";
import { Stats } from "@styled-icons/boxicons-regular/Stats";
import { DashboardIcon, MapIcon } from "@components/icons";
import "@modules/Projects/components/Project.css";

export default function ViewTypeButton({ id }) {
  const getButtonClassName = ({ isActive }) =>
    `project-view-type-button${isActive ? " active" : ""}`;

  return (
    <div className="project-view-type-toggle">
      <NavLink
        to={`/project/${id}/dashboard`}
        className={getButtonClassName}
        aria-label="dashboard"
        title="Dashboard"
      >
        <ProjectDashboardIcon size={"1.4em"} />
      </NavLink>
      <NavLink
        to={`/project/${id}/list/trees`}
        className={getButtonClassName}
        aria-label="list"
        title="List View"
      >
        <MenuIcon />
      </NavLink>
      <NavLink
        to={`/project/${id}/map`}
        className={getButtonClassName}
        aria-label="map"
        title="Map View"
      >
        <ProjectMapIcon />
      </NavLink>
      <NavLink
        to={`/project/${id}/datascience`}
        className={getButtonClassName}
        aria-label="datascience"
        title="Datascience View"
      >
        <DataScatterIcon />
      </NavLink>
    </div>
  );
}

const MenuIcon = styled(List)`
  width: 1.4em;
  height: 1.4em;
  color: currentColor;
`;
const DataScatterIcon = styled(Stats)`
  width: 1.4em;
  height: 1.4em;
  color: currentColor;
`;
const ProjectDashboardIcon = styled(DashboardIcon)`
  color: currentColor;
`;
const ProjectMapIcon = styled(MapIcon)`
  color: currentColor;
  width: 1.4em;
  height: 1.4em;
`;
